import {
  CUSTOM_ELEMENTS_SCHEMA,
  ModuleWithProviders,
  NgModule,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import {
  NbActionsModule,
  NbLayoutModule,
  NbMenuModule,
  NbSearchModule,
  NbSidebarModule,
  NbUserModule,
  NbContextMenuModule,
  NbButtonModule,
  NbSelectModule,
  NbIconModule,
  NbThemeModule,
  NbTabsetModule,
  NbRouteTabsetModule,
  NbCardModule,
  NbInputModule,
  NbSpinnerModule,
  NbAlertModule,
} from '@nebular/theme';
import { NbEvaIconsModule } from '@nebular/eva-icons';
import { NbSecurityModule } from '@nebular/security';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import {
  FooterComponent,
  FooterMobileComponent,
  HeaderComponent,
  SearchInputComponent,
  TinyMCEComponent,
  LoaderComponent,
} from './components';
import {
  CapitalizePipe,
  PluralPipe,
  RoundPipe,
  TimingPipe,
  NumberWithCommasPipe,
} from './pipes';
import {
  OneColumnLayoutComponent,
  ThreeColumnsLayoutComponent,
  TwoColumnsLayoutComponent,
} from './layouts';
import { DEFAULT_THEME } from './styles/theme.default';
import { COSMIC_THEME } from './styles/theme.cosmic';
import { CORPORATE_THEME } from './styles/theme.corporate';
import { DARK_THEME } from './styles/theme.dark';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { BackButtonComponent } from './components/back-button/back-button.component';
import { AbsensiDialogComponent } from './components/absensi-dialog/absensi-dialog.component';
import { PromptDialogComponent } from './components/prompt-dialog/prompt-dialog.component';
import { CustomDialogComponent } from './components/custom-dialog/custom-dialog.component';
import { AbsensiLuarDialogComponent } from './components/absensi-luar-dialog/absensi-luar-dialog.component';
import { DownloadPopupComponent } from './components/download-popup/download-popup.component';
import { FormPromptDialogComponent } from './components/form-prompt-dialog/form-prompt-dialog.component';
import { MenuSelectComponent } from './components/menu-select/menu-select.component';

const NB_MODULES = [
  NbInputModule,
  NbLayoutModule,
  NbMenuModule,
  NbUserModule,
  NbCardModule,
  NbActionsModule,
  NbSearchModule,
  NbSidebarModule,
  NbContextMenuModule,
  NbButtonModule,
  NbSelectModule,
  NbIconModule,
  NbEvaIconsModule,
  NbTabsetModule,
  NbRouteTabsetModule,
  FormsModule,
  ReactiveFormsModule,
  NbSpinnerModule,
  NbAlertModule,
];
const COMPONENTS = [
  HeaderComponent,
  FooterComponent,
  FooterMobileComponent,
  SearchInputComponent,
  TinyMCEComponent,
  OneColumnLayoutComponent,
  ThreeColumnsLayoutComponent,
  TwoColumnsLayoutComponent,
  LoaderComponent,
  ConfirmDialogComponent,
  BackButtonComponent,
  CustomDialogComponent,
  PromptDialogComponent,
  AbsensiDialogComponent,
  AbsensiLuarDialogComponent,
  DownloadPopupComponent,
  FormPromptDialogComponent,
  MenuSelectComponent,
];
const PIPES = [
  CapitalizePipe,
  PluralPipe,
  RoundPipe,
  TimingPipe,
  NumberWithCommasPipe,
];

@NgModule({
  imports: [CommonModule, ...NB_MODULES, RouterModule],
  exports: [CommonModule, ...PIPES, ...COMPONENTS],
  declarations: [...COMPONENTS, ...PIPES, FormPromptDialogComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ThemeModule {
  static forRoot(): ModuleWithProviders<ThemeModule> {
    return {
      ngModule: ThemeModule,
      providers: [
        ...NbThemeModule.forRoot(
          {
            name: 'default',
          },
          [DEFAULT_THEME]
        ).providers,
      ],
    };
  }
}
